import { render, staticRenderFns } from "./ColorBlockText.vue?vue&type=template&id=c246bbfa&scoped=true&"
import script from "./ColorBlockText.vue?vue&type=script&lang=js&"
export * from "./ColorBlockText.vue?vue&type=script&lang=js&"
import style0 from "./ColorBlockText.vue?vue&type=style&index=0&id=c246bbfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c246bbfa",
  null
  
)

export default component.exports